import {useEffect, useState} from "react";

import Loading from "@/app/loading";
import DownloadLink from "@/components/ui/download-link";
import {FileProps} from "@/types";
import {Table} from "react-bootstrap";
import {Button, Modal} from "react-bootstrap";

import api from "@/lib/api";

type DatasetModalProps = {
  datasetId: number;
  showDatasetModal: boolean;
  handleCloseDatasetModal: () => void;
  handleOpenModuleModal: (moduleId: number) => void;
};

type DatasetModalData = {
  dataset: {
    value: number;
    label: string;
  };
  description: string;
  codebook: FileProps;
  modules: {
    value: number;
    label: string;
  }[];
};

export async function getDatasetModalData(dataset_id: number) {
  try {
    const response = await api.get<DatasetModalData>(
      `/hrd/dataset/${dataset_id}`
    );
    return response;
  } catch (error) {
    console.error("Error fetching harmonzied data data:", error);
    throw new Error("Failed to fetch harmonzied data");
  }
}

export default function DatasetModal({
  showDatasetModal,
  datasetId,
  handleCloseDatasetModal,
  handleOpenModuleModal,
}: DatasetModalProps) {
  const [datasetData, setDatasetData] = useState<DatasetModalData>();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      if (datasetId) {
        setLoading(true);
        const response = await getDatasetModalData(datasetId);
        setDatasetData(response);
        setLoading(false);
      }
    };
    fetchData();
  }, [showDatasetModal, datasetId]);

  return (
    <>
      <Modal
        show={showDatasetModal}
        onHide={handleCloseDatasetModal}
        size='xl'
        aria-labelledby='srv-item-modal'
      >
        <Modal.Header closeButton>
          <Modal.Title>{datasetData?.dataset?.label}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {loading ? (
            <Loading />
          ) : (
            <>
              <p>
                <span
                  className='g2-link-blue'
                  onClick={() => {
                    handleCloseDatasetModal();
                  }}
                >
                  Harmonized Data
                </span>{" "}
                &gt;{" "}
                <span className='g2-text-grey'>
                  {datasetData?.dataset.label}
                </span>{" "}
                &gt;{" "}
                <span className='g2-text-grey'>
                  Modules ({datasetData?.modules?.length || 0})
                </span>
              </p>
              <p className='g2-text-grey'>
                {datasetData?.description}
                {datasetData?.codebook && (
                  <DownloadLink file={datasetData.codebook} target='_blank'>
                    {datasetData.dataset.label} codebook.
                  </DownloadLink>
                )}
              </p>
              <Table
                className='table table-striped table-hover table-bordered'
                width='100%'
              >
                <thead className='table-dark'>
                  <tr>
                    <th>Title</th>
                  </tr>
                </thead>
                <tbody>
                  {datasetData?.modules?.map((item, index) => (
                    <tr key={index}>
                      <td>
                        <span
                          className='g2-link-blue'
                          onClick={() => {
                            handleOpenModuleModal(item.value);
                            handleCloseDatasetModal();
                          }}
                        >
                          {item.label}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' onClick={handleCloseDatasetModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
